<template>
  <div class="dynamicRoute" id="dynamicRoute">
    <div class="psPatientsList">
      <ps-upper-bar :site="{ site: 'Pacientes' }" :newButton="true" :tooltip="'Nuevo paciente'" @newItem="newPatient"></ps-upper-bar>
      <div class="row">
        <ps-patients-list-search-bar></ps-patients-list-search-bar>
      </div>
      <ps-patients-list-table></ps-patients-list-table>
    </div>
  </div>
</template>

<script>
import PsUpperBar from '@/components/layout/PsUpperBar.vue'
import PsPatientsListSearchBar from './widgets/PsPatientsListSearchBar.vue'
import PsPatientsListTable from './widgets/PsPatientsListTable.vue'

export default {
  name: 'PsPatientsList',
  components: { PsPatientsListSearchBar, PsPatientsListTable, PsUpperBar },
  methods: {
    newPatient () {
      this.$router.push('/patients/detail/0')
    }
  }
}
</script>

<style scoped>
  .psPatientsList { display: flex; flex-direction: column; width: 100%; height: 99%; margin-bottom: 0;}

  .dynamicRoute { 
    display: flex; 
    flex-direction: column; 
    z-index: 1; 
    min-height: 90%; 
    background-color: #e1e1e1; 
    width: 94%; 
    min-width: 1200px;
    margin: 16px 16px 0 0; 
    border-radius: 70px 70px 0 0 ;
    padding: 0 50px;
    overflow: hidden;
  }
  
  /* Medium devices (tablets, less than 992px) */
  @media (max-width: 991.98px) {
    .psPatientsList { height: 100%;}
  }
</style>